/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */



// third party
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VueMask from 'v-mask'
Vue.use(VueMask);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import TextareaAutosize from 'vue-textarea-autosize'
Vue.use(TextareaAutosize)

// infinite scroll
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

// Visible
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

Vue.use(require('vue-moment'));

// resources
import helpers from "./helpers";
import LandingPageHeader from "./views/LandingPageHeader";

Vue.use(LandingPageHeader);
//
const plugin = {
    install () {
        Vue.helpers = helpers
        Vue.prototype.$helpers = helpers
    }
}
Vue.use(plugin);



// import CKEditor from '@ckeditor/ckeditor5-vue';
// Vue.use( CKEditor );

// //
// Vue.prototype.$appConfig = {
//     document_id: null,
//     app_type: null,
//     app_id: null,
//     app_config: {}
// };
import BootstrapVue from 'bootstrap-vue';
import ApiService from './api/api.service';
import veevalidate from './util/veevalidate'

import Vue from 'vue';
import MainApp from "./components/MainApp";
import store from './store';
import router from './router';
import VueLazyLoad from 'vue-lazyload'
import VModal from 'vue-js-modal/dist/index.nocss.js'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)
Vue.use(VModal, { dialog: true})
Vue.use(BootstrapVue);
Vue.use(VueLazyLoad);


import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
    id: process.env.MIX_GA,
    router,
    checkDuplicatedScript: true,
    disableScriptLoader: true,
})

ApiService.init();

window.onload = function () {
    const app = new Vue({
        router,
        store,
        render: h => h(MainApp),
        mounted() {
            // debugger
        },
    }).$mount('#app');
}
